<template>
  <v-tabs-items v-model="tab">
    <slot></slot>
  </v-tabs-items>
</template>

<script>
export default {
  name: 'TabsContent',
  props: {
    value: {
      type: [String, Number, Object],
      required: true,
    },
  },
  computed: {
    tab: {
      set: function (value) {
        this.$emit('input', value);
      },
      get: function () {
        return this.value;
      },
    },
  },
};
</script>
